module.exports = __webpack_public_path__ + "static/media/ragismeni-vera-book-cover.cb4458c1.jpg";